<script>

import {mapState, mapMutations} from "vuex";
import DepService from "@/api/services/depService";
import CarouselComponent from "@/views/components/CarouselComponent.vue";
import {setAuthToken} from "@/functions/authTokenStorage";

export default {
  name: "SubmitOtpView",
  components: {CarouselComponent},
  computed: {
    ...mapState(['msisdn', 'user', 'serviceId', 'productId', 'currentSeason'])
  },
  data() {
    return {
      OTP: undefined,
      hastOtpSent: false,
      otpLimitExceeded: false,
      invalidOtp: false,
      otpAlreadyUsed: false,
      otpExpired: false,
      otpResent: false,
    }
  },
  methods: {
    ...mapMutations(['setUser']),
    async continueClicked() {
      if (!this.OTP || String(this.OTP).trim() === '') {
        this.invalidOtp = true;
        return;
      }

      const validateOTPResponse = await DepService.validateOtp(this.msisdn, this.productId, this.OTP);

      if (validateOTPResponse.data.sessionId) {
        setAuthToken(validateOTPResponse.data.token);
        const user = (await DepService.getUserViaProductId(this.msisdn, this.productId)).data.user;
        await DepService.trackLogin(user.msisdn, this.productId, this.getMTNServiceIdFromDescription(user.serviceName));
        this.setUser(user);
        if (this.user.username === null) {
          this.$router.push('/username');
        } else if (this.user.username) {
          this.$router.push('/');
        }
      } else {
        if (validateOTPResponse.data.OTPAttemptCount > 2) {
          this.hastOtpSent = true;
          this.invalidOtp = false
          this.otpLimitExceeded = true;
        } else this.invalidOtp = true;
      }
      if (validateOTPResponse.data.UsedOTP) {
        this.hastOtpSent = true;
        this.invalidOtp = false;
        this.otpAlreadyUsed = true;
      }
      if (validateOTPResponse.data.ExpiredOTP) {
        this.hastOtpSent = true;
        this.invalidOtp = false;
        this.otpExpired = true;
      }
    },
    async resendOtp() {
      this.OTP = undefined;
      this.otpExpired = false;
      this.otpAlreadyUsed = false;
      this.invalidOtp = false;
      this.otpResent = false;
      await DepService.requestOtp(this.msisdn, this.productId);
      this.otpResent = true;
    },
    getMTNServiceIdFromDescription(description) {
      const serviceMap = {
        "mzansi-rhythm-free": 34,
        "mzansi-rhythm-daily": 35,
        "mzansi-rhythm-weekly": 36,
        "mzansi-rhythm-monthly": 37
      };

      return serviceMap[description] || null;
    },
  }
  ,
}
</script>

<template>
  <div class="d-flex flex-column justify-content-start align-items-center col-12 mt-5 position-relative">
    <div class="d-flex flex-column justify-content-center align-items-start col-11">
      <img src="@/assets/onboarding/onboarding-logo.png" class="col-5"/>
    </div>
    <div class="d-flex flex-column justify-content-start align-items-end col-11">
      <img src="@/assets/onboarding/onboarding-img.png" class="col-8"/>
    </div>
    <div class="text-center fw-bold col-7 fs-6 mt-3 mb-5" style="color: #000F56">
      Please enter the OTP
      sent via SMS
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-12 gap-3">
      <input @keyup.enter="continueClicked()" v-model="OTP" class="col-11 msisdn-input p-4 text-center"
             inputmode="numeric" placeholder="Enter OTP"/>
      <div class="invalid-text" v-if="invalidOtp">Invalid OTP, please re-enter the OTP</div>
      <div class="invalid-text" v-if="otpLimitExceeded">You have exceeded your OTP attempt limit</div>
      <div class="invalid-text" v-if="otpAlreadyUsed">This OTP has already been used</div>
      <div class="invalid-text" v-if="otpExpired">This OTP has expired.</div>
      <div class="success-text" v-if="otpResent">A new OTP has been sent to your number.</div>
      <div class="col-11 p-4 continue-btn text-center fw-bold fs-6" @click="continueClicked()">Continue</div>
      <div class="resend-btn text-center fw-bold fs-6" v-if="otpExpired || otpAlreadyUsed" @click="resendOtp()">Resend
        OTP
      </div>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-11 mt-3">
      <CarouselComponent :season="currentSeason"/>
    </div>
    <div class="d-flex flex-column justify-content-center text-center align-items-center col-7 mb-4 mt-4"
         style="color: #000F56">
      By entering your number you agree to our privacy policy and <span class="text-decoration-underline"
                                                                        @click="this.$router.push('/terms')">Terms & Conditions.</span>
    </div>
  </div>
</template>

<style scoped>
.msisdn-input {
  border-radius: 27px;
  border: 1px solid #CCC;
}

.continue-btn {
  border-radius: 30px;
  background: #FFCB05;
}

.invalid-text {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-left: 10px;
  padding-right: 10px;
  color: #ff0008;
}

.success-text {
  font-size: 12px;
  color: #28a745;
  text-align: center;
}

.resend-btn {
  cursor: pointer;
  color: #000F56;
  text-decoration: underline;
}
</style>
